import http from '@/api/client'
import type { ApiResponse, PageResponse } from '@/types/api'
import type { MessageBizType, MessageItem, MessageListParams } from '@/types/message'

/** `GET /app/msg/list?type=&pageNum=&pageSize=` → 后端把 `rows/total` 平铺到 body 上，不是 `data`。 */
export function getMessageList(
  params: MessageListParams = {},
): Promise<PageResponse<MessageItem>> {
  return http.get<PageResponse<MessageItem>>('/app/msg/list', { params }).then((r) => r.data)
}

/** `GET /app/msg/unread-count` → `data` 为裸数字（不是 `{count: N}`）。 */
export function getUnreadCount(): Promise<ApiResponse<number>> {
  return http.get<ApiResponse<number>>('/app/msg/unread-count').then((r) => r.data)
}

/** `POST /app/msg/read` body `{ids:number[]}`。 */
export function markRead(ids: number[]): Promise<ApiResponse<null>> {
  return http.post<ApiResponse<null>>('/app/msg/read', { ids }).then((r) => r.data)
}

/** `POST /app/msg/read-all`。 */
export function markAllRead(): Promise<ApiResponse<null>> {
  return http.post<ApiResponse<null>>('/app/msg/read-all').then((r) => r.data)
}

/** `POST /app/msg/delete` body `{ids:number[]}`。 */
export function deleteMessage(ids: number[]): Promise<ApiResponse<null>> {
  return http.post<ApiResponse<null>>('/app/msg/delete', { ids }).then((r) => r.data)
}

/** 业务类型到展示图标的辅助（前端决定，与后端解耦）。 */
export const MSG_BIZ_ICON: Record<MessageBizType, string> = {
  ORDER: 'clipboard-check',
  CERT: 'badge-check',
  COURSE: 'book-open',
  REVENUE: 'wallet',
  SYSTEM: 'megaphone',
}

export const MSG_BIZ_TONE: Record<MessageBizType, 'blue' | 'green' | 'amber' | 'pink' | 'muted'> = {
  ORDER: 'blue',
  CERT: 'green',
  COURSE: 'amber',
  REVENUE: 'green',
  SYSTEM: 'pink',
}

export const MSG_BIZ_LABEL: Record<MessageBizType, string> = {
  ORDER: '订单',
  CERT: '认证',
  COURSE: '课程',
  REVENUE: '收益',
  SYSTEM: '系统',
}
